// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconEurm } from "../../../icons/full/build/icon-eurm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const EurmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconEurm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  EurmIcon.displayName = 'EurmIcon';
}

export default EurmIcon;